import routes from "./routes";
import OpenAiTotalProjectsIcon from "../assets/images/open-ai-total-projects.svg";
import RemainingWordsIcon from "../assets/images/remaining-words.svg";
import AssignedToEditorsIcon from "../assets/images/assigned-to-editors.svg";

const { REACT_APP_GOOGLE_CLIENT_ID } = process.env;

const openAiContentTypes = {
  SEO_META_TAG: {
    _id: "SEO_META_TAG",
    name: "SEO Meta Tag",
    description:
      "Generate meta tags for your website to improve search engine rankings and visibility.",
    url: routes.OPEN_AI_SEO_META_TAG,
    active: true,
  },
  SOCIAL_BOOKMARKING: {
    _id: "SOCIAL_BOOKMARKING",
    name: "Social Bookmarking",
    url: routes.OPEN_AI_SOCIAL_BOOKMARKING,
    description:
      "Increase website visibility with social bookmarking services.",
    active: true,
  },
  BLOG: {
    _id: "BLOG",
    name: "Guided Blog",
    description:
      "Give us a title and get a suitable introduction, body & conclusion – in fewer than 5 minutes!",
    url: routes.OPEN_AI_BLOG,
    steps: [
      { name: "Describe your business" },
      { name: "Choose your topic" },
      { name: "Select blog headings" },
      { name: "First Draft" },
      { name: "See writely magic" },
    ],
    active: true,
  },
  QUORA_QNA: {
    _id: "QUORA_QNA",
    name: "Quora QnA",
    url: routes.OPEN_AI_QUORA_QNA,
    description:
      "Get answers to your questions on Quora with Generate QUORA QNA.",
    active: true,
  },
  SOCIAL_MEDIA_COPY: {
    _id: "SOCIAL_MEDIA_COPY",
    name: "Social Media Copy",
    url: routes.OPEN_AI_SOCIAL_MEDIA_COPY,
    description:
      "Create a buzz around your brand with a copy that educates & engages your audience",
    active: false,
  },
  PAID_AD_COPY: {
    _id: "PAID_AD_COPY",
    name: "Paid Ad Copy",
    url: routes.OPEN_AI_PAID_AD_COPY,
    description: "Get a compelling copy to beckon & bedazzle your audience",
    active: true,
  },
  KEYWORD_GENERATOR: {
    _id: "KEYWORD_GENERATOR",
    name: "Keyword Generator",
    url: routes.OPEN_AI_KEYWORD_GENERATOR,
    description:
      "Discover the perfect keywords for your business with our keyword generator",
    active: true,
  },
  TRANSLATOR: {
    _id: "TRANSLATOR",
    name: "Translator",
    url: routes.OPEN_AI_TRANSLATOR,
    description:
      "Translate your text into  wide range of supported languages including English, Hindi, Spanish, French, German, Mandarin, Arabic, and many more",
    active: true,
  },
  BLOG_OUTLINE: {
    _id: "BLOG_OUTLINE",
    name: "Blog Outline",
    url: routes.OPEN_AI_BLOG_OUTLINE,
    description:
      "Give us a title and get a suitable introduction, body & conclusion – in fewer than 5 minutes and Redefines Modern Marketing Strategies and Amplifies Brand Success!",
    active: true,
  },
  BLOG_NEW: {
    _id: "BLOG_NEW",
    name: "Instant Blog",
    url: routes.OPEN_AI_BLOG_NEW,
    description:
      "Instantly enrich your mind with our concise and insightful blog",
    active: true,
  },
  LINKEDIN_PAID: {
    _id: "LINKEDIN_PAID",
    name: "Linkedin Paid Ad Copy",
    url: routes.OPEN_AI_LINKEDIN_PAID,
    description:
      "Supercharge your LinkedIn presence with AI-driven ads! Elevate your brand, captivate your audience, and dominate the professional sphere. Stand out, connect deeply, and maximize your impact!",
    active: true,
  },
  INSTAGRAM_PAID: {
    _id: "INSTAGRAM_PAID",
    name: "Instagram Paid Ad Copy",
    url: routes.OPEN_AI_INSTAGRAM_PAID,
    description:
      "AI-fueled Instagram ads: Elevate your brand, engage your audience, and dominate the feed",
    active: true,
  },
  TWITTER_PAID: {
    _id: "TWITTER_PAID",
    name: "Twitter Paid Ad Copy",
    url: routes.OPEN_AI_TWITTER_PAID,
    description:
      "Transform your Twitter presence with AI-fueled ads - captivate, connect, and conquer the digital sphere!",
    active: true,
  },
};

const constants = Object.freeze({
  GOOGLE_CLIENT_ID: REACT_APP_GOOGLE_CLIENT_ID,

  // User access token key
  ACCESS_TOKEN: "accessToken",

  // sidebar collapsed key
  IS_SIDEBAR_COLLAPSED: "isSidebarCollapsed",

  // Templates types
  TEMPLATE_TYPES: ["writing", "design", "translation"],

  // Paging
  DEFAULT_PAGING: {
    limit: 30,
    offset: 0,
  },

  // onModel keys for comments & attachments
  ON_MODEL: {
    TASK: "Task",
    PROJECT_ITEM: "Item",
  },

  // Actions
  ACTION_TYPES: {
    LOGOUT: "LOGOUT",
  },

  // Users Role Ids
  ROLE_IDS: {
    SUPER_ADMIN: "super_admin",
    ADMIN: "admin",
    FREELANCER: "freelancer",
    CLIENT: "client",
    EDITOR: "editor",
    MANAGER: "manager",
    CLIENT_AI_BOT: "client_ai_bot"
  },

  // currencies
  CURRENCIES: {
    INR: {
      _id: "INR",
      PER_WORD_LIMIT: 40,
      PER_CONTENT_LIMIT: 10000,
      SYMBOL: "₹",
    },
    USD: {
      _id: "USD",
      PER_WORD_LIMIT: 10,
      PER_CONTENT_LIMIT: 1000,
      SYMBOL: "$",
    },
    GBP: {
      _id: "GBP",
      PER_WORD_LIMIT: 10,
      PER_CONTENT_LIMIT: 1000,
      SYMBOL: "£",
    },
    EURO: {
      _id: "EURO",
      PER_WORD_LIMIT: 10,
      PER_CONTENT_LIMIT: 1000,
      SYMBOL: "€",
    },
  },
  RATINGS_TAGS: [
    "Quality of writing",
    "Punctuality",
    "Adherence to Template",
    "Level of research/Accuracy of information",
    "Readability",
  ],

  //project status
  PROJECT_STATUS: {
    QUEUED: { name: "Queued", _id: "queued" },
    IN_PROGRESS: { name: "In Progress", _id: "inprogress" },
    CLOSED: { name: "Closed", _id: "closed" },
  },

  // task filter type
  FILTER_TYPE: {
    CREATED_BY: { name: "Created By", _id: "created_by" },
    WRITER: { name: "Assigned Writer", _id: "writer" },
    ASSIGNED_TO: { name: "Assigned To", _id: "assigned_to" },
    CREATED_DATE: { name: "Created Date", _id: "created_date" },
  },

  FILTER_TYPE_DATE: {
    All: { name: "All", _id: "all_data" },
    CURRENT_MONTH: { name: "Current Month", _id: "current_month" },
    LAST_MONTH: { name: "Last Month", _id: "last_month" },
    CUSTOM_DATE: { name: "Custom Date", _id: "custom_date" },
  },

  // Notification types
  NOTIFICATION_TYPES: {
    PROJECTASSIGNED: "projectAssigned",
    SHAREDWITHPROJECT: "sharedWithProject",
    ASSIGNEDTASK: "assignedTask",
    TASKCOMPLETION: "taskCompleted",
    STARTASSESSMENT: "startAssessment",
    SUBMITASSESSMENT: "submitAssessment",
    BULKTASKUPLOAD: "bulkTaskUpload",
    MENTIONINTASK: "task",
  },

  // project task status
  PROJECT_TASK_STATUS: {
    INITIATE: "initiate",
    ASSIGNED: "assigned",
    IN_PROGRESS: "inprogress",
    IN_REVIEW: "inreview",
    REWORK: "rework",
    COMPLETED: "completed",
    APPROVED: "approved",
  },
  // task status options
  TASK_STATUS_OPTIONS: {
    INITIATE: { _id: "initiate", name: "To Do" },
    IN_PROGRESS: { _id: "inprogress", name: "In Progress" },
    IN_REVIEW: { _id: "inreview", name: "In Review" },
    COMPLETED: { _id: "completed", name: "Completed" },
    APPROVED: { _id: "approved", name: "Accepted" },
  },

  // Project item task type
  TASK_TYPE: {
    ALL: { _id: "all", name: "All" },
    MY_TASK: { _id: "myTask", name: "Your Todo" },
    OTHER_TASK: { _id: "otherTask", name: "Other" },
    CLOSE_TASK: { _id: "closeTask", name: "Closed" },
  },

  CONTENT_VOICE_TONES: [
    "Humorous/Entertaining",
    "Serious",
    "Infomal",
    "Professional/Formal",
    "Explanatory",
    "Personal",
    "Narrative",
    "Casual",
  ],
  ENGLISH_VARIANT_SELECTION: [
    "British English",
    "American English",
    "Canadian English",
    "Australian English",
    "South African English",
    "Singaporean English",
    "Nigerian English",
  ],
  BRAND: [
    "Healthcare",
    "Finance",
    "Footwear",
    "Fashion",
    "Technology",
    "Automotive",
    "Rental Spaces",
    "E-commerce",
    "Food and Beverage",
    "Travel and Tourism",
    "Entertainment",
    "Real Estate",
    "Education",
    "Renewable Energy",
    "Sports and Fitness",
    "Home and Garden",
    "Beauty and Wellness",
    "Agriculture and Farming",
  ],

  CONTENT_PERSPECTIVES: ["First person", "Second person", "Third person"],

  // Freelancer Experties Category
  EXPERTIES_CATEGORY: {
    "Content Writing & Editing":
      "Articles & Blog posts\nProofreading & editing\nWebsite Content\nBook/eBook Writing\nCreative or Technical Writing",

    "Career Writing": "Resume Writing\nCover Letters\nLinkedIn Profiles",
    "Journalism, PR":
      "Non-fiction writing\nInvestigative Journalism\nNews Articles\nPress releases\nInterviews",
    Storytelling: "Scriptwriting\nSpeechwriting\nPodcasts writing",
    "Business Writing":
      "Brand Voice and Tone\nCase Studies\nWhite Papers\nGrant Writing\nProduct Descriptions",
    Other: "Everything else in content writing universe",
  },

  OPEN_AI_DASHBOARD_COUNTERS: [
    {
      _id: "totalTaskCount",
      name: "Total Projects",
      icon: OpenAiTotalProjectsIcon,
    },
    {
      _id: "totalWordsRemainingCount",
      name: "Words Remaining",
      icon: RemainingWordsIcon,
    },
    {
      _id: "totalTaskAssignedToEditorsCount",
      name: "Assigned To Editors",
      icon: AssignedToEditorsIcon,
    },
  ],

  //fields for computing profile completion %age
  PROFILE_FIELDS_KEY: [
    "first_name",
    "gst_vat",
    "address",
    "additional_details",
    "bank_details",
    "contact_number",
    "expertise",
    "industry",
    "linkedin_URL",
    "website",
  ],
  TOP_LANGUAGES: [
    "Afrikaans",
    "Akan",
    "Albanian",
    "Amharic",
    "Arabic",
    "Armenian",
    "Assamese",
    "Azerbaijani",
    "Balochi",
    "Bamanankan",
    "Bashkort",
    "Belarusian",
    "Bemba",
    "Bengali",
    "Bhojpuri",
    "Bosnian",
    "Bulgarian",
    "Burmese",
    "Cantonese",
    "Catalan",
    "Cebuano",
    "Chewa",
    "Chhattisgarhi",
    "Chittagonian",
    "Czech",
    "Danish",
    "Deccan",
    "Dholuo",
    "Dutch",
    "English",
    "Esperanto",
    "Estonian",
    "Ewe",
    "Finnish",
    "French",
    "Fula",
    "Ga",
    "Gan",
    "Georgian",
    "German",
    "Gikuyu",
    "Gondi",
    "Greek",
    "Gujarati",
    "Hakka",
    "Hausa",
    "Hebrew",
    "Hiligaynon",
    "Hindi",
    "Hmong",
    "Hungarian",
    "Igbo",
    "Ilokano",
    "Indonesian",
    "Italian",
    "Japanese",
    "Javanese",
    "Jin",
    "Kamba",
    "Kannada",
    "Kazakh",
    "Khmer",
    "Kinyarwanda",
    "Kirundi",
    "Korean",
    "Kurdish",
    "Kyrgyz",
    "Lao",
    "Latvian",
    "Lingala",
    "Lithuanian",
    "Luganda",
    "Macedonian",
    "Madurese",
    "Magahi",
    "Maithili",
    "Malagasy",
    "Malay",
    "Malayalam",
    "Mandarin",
    "Marathi",
    "Marwari",
    "Min Bei",
    "Min Dong",
    "Min Nan",
    "Mossi",
    "Nepali",
    "Newari",
    "Northern Uzbek",
    "Norwegian",
    "Odia",
    "Oromo",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Quechua",
    "Romanian",
    "Russian",
    "Saraiki",
    "Sindhi",
    "Sinhalese",
    "Slovak",
    "Slovenian",
    "Somali",
    "Soninke",
    "Spanish",
    "Sundanese",
    "Swahili",
    "Swedish",
    "Sylheti",
    "Tagalog",
    "Tajik",
    "Tamil",
    "Tatar",
    "Telugu",
    "Thai",
    "Tigrinya",
    "Turkish",
    "Turkmen",
    "Ukrainian",
    "Urdu",
    "Uyghur",
    "Uzbek",
    "Vietnamese",
    "Wu",
    "Xhosa",
    "Xiang",
    "Yiddish",
    "Yoruba",
    "Zhuang",
    "Zulu",
  ],

  OPEN_AI_TASK_FIELDS: [
    {
      _id: "task_name",
      label: "Project name",
      help_text: "Project name",
      value: "",
      type: "text",
      mandatory: true,
      validation: "Please enter project name",
    },
    {
      _id: "content_type",
      label: "Content type",
      help_text: "Select content type",
      value: "",
      type: "dropdown",
      options: Object.values(openAiContentTypes)
        .map((contentType) => contentType.name)
        .join("|"),
      mandatory: true,
      validation: "Please select any content type",
      disabled: true,
    },
    {
      _id: "content",
      label: "Content",
      value: "",
      type: "textarea",
    },
  ],

  AUTO_GENERATE_CONTENT_TYPES: openAiContentTypes,

  SOCIAL_MEDIA_PLATFORMS: {
    facebook: {
      _id: "facebook",
      name: "Facebook",
      logo: "/img/SocialMediaLogo/facebook.svg",
      query: {
        heading: "140 characters",
      },
    },
    google: {
      _id: "google",
      name: "Google",
      logo: "/img/SocialMediaLogo/google.svg",
      query: {
        heading: "40 characters",
        description: "100 characters",
      },
    },
    twitter: {
      _id: "twitter",
      name: "Twitter",
      logo: "/img/SocialMediaLogo/twitter.svg",
    },
    linked_in: {
      _id: "linked_in",
      name: "LinkedIn",
      logo: "/img/SocialMediaLogo/linkedin.svg",
      query: {
        heading: "220 characters",
        description: "330 characters",
      },
    },
    // youtube: {
    //   _id: "youtube",
    //   name: "Youtube",
    //   logo: "/img/SocialMediaLogo/youtube.svg",
    // },
    instagram: {
      _id: "instagram",
      name: "instagram",
      logo: "/img/SocialMediaLogo/instagram.svg",
      query: {
        heading: "140 characters",
      },
    },
    // tik_tok: {
    //   _id: "tik_tok",
    //   name: "Tik-Tok",
    //   logo: "/img/SocialMediaLogo/tiktok.svg",
    // },
    // bing: {
    //   _id: "bing",
    //   name: "Bing",
    //   logo: "/img/SocialMediaLogo/bing.svg",
    // },
    // pinterest: {
    //   _id: "pinterest",
    //   name: "Pinterest",
    //   logo: "/img/SocialMediaLogo/pinterest.svg",
    // },
  },

  URL_REGEX:
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,

  // Assessment levels
  ASSESSMENTS_LEVEL: ["Beginner", "Intermediate", "Expert"],

  // Content types list
  CONTENT_TYPE:
    "Website Content|Free Blog|Website Blog|FAQ's|Social Bookmarking|Outreach Article|News|Reviews|Meta Tags|Social Media|Image Copies|Post Copies|Blog Outline|Blog New |Linkedin Paid",

  // Search types list
  SEARCH_TYPE:
    "Project One|Project Two|Project Three|Project Four|Project Five|Project Six|",

  // Industry option list
  INDUSTRY:
    "Deep Tech (ML, AI, Data Science, Crypto, Cyber Security)|IT - Software and Application Development|Entrepreneurship and Venture Capital|Business and Corporate|Banking and Insurance (BFSI)|Economics and Trade|News and Current Affairs|Government and Politics|Art and Design|Entertainment and Cinema|Others|Engineering & Services|Electronics and Technology|History and Culture|Religion and Mythology|Generic|Interior Design and Decor|Lifestyle|Fashion And Apparel|Sports And Fitness|Food and Nutrition|Medicines and Pharmaceutical|Healthcare and Wellness|Legal|Accounting and Taxation|Travel & Hospitality|Logistics & Shipping|Real Estate and Rental|Parenting, Babycare and Elderly Care|Career and Education|Marketing And Advertising|Digital Marketing - (SEO, PPC, SEM)|Human Resources|Beauty and Cosmetics|E-commerce|Automobiles|Online Gaming & e-Sports|Web Design And UI/UX|Books And Literature|Events|Manufacturing & Industrial Content|Agriculture Forestry Fishing and Hunting|Pet and Animal Care|Retail|Oil, Gas and Energy",

  // SubIndustry option list
  SUB_INDUSTRY:
    "Legal Tech and Legal Services|Contract Management|Intellectual Property|International Taxation|Tax Planning, Compliance, Policy and Services, Tax Reporting and Strategy|Audit and Assurance - Actuary, Corporate Reporting, Financial Audits, Risk Assurance|Indian Taxation - Goods and Service Tax (GST), VAT, Tax Audits, Tax Finance, TDS, Policies and Compliances|Accounting and Invoicing Solutions|Transactions and Corporate Finance - M&A, Valuation, Modelling and Economics|Cost & Management Accounting, Financial Planning|Regulatory Reporting|Underwriting|Asset Finance/ Leasing|Asset Management|Micro-Finance|Banking - Commercial, Payments, Co-operative, Small Finance|Investment Banking|Payments - Apps|Regulatory Tech|Commercial Finance|Wealth Management - Investment, Stocks, Mutual Funds, Saving Schemes|Insurance - Health, Home, Auto, Life, InsureTech, etc.|Advisory - Investment, Valuation, Risk, etc.|FinTech|Foreign Exchange and Money Markets|Cryptocurrencies|Financial Exchanges|Design thinking|CSR|Capital Markets|Venture Capital and Private Equity|Entrepreneurship|Advanced Manufacturing (3D Printing)|Artificial Intelligence|Blockchain, Cryptocurrency & NFTs|Biotechnology - Environmental, Biomedical, Genetic, Industrial and Bioinformatics|Chatbots|Cloud Security|Computer Vision|Cybersecurity & Data Privacy|Data Science, Data Analytics and Data Mining|Drones|IoT|Image Recognition|Machine Learning & Deep Learning|Natural Language Processing (NLP) and NLU|Nanotechnology|Quantum Computing|Robotics|SpaceTech|Urban Air Mobility|Augmented Reality / Virtual Reality (VR)|Hardware|Embedded Software|Embedded Systems|Telecommunications|Consumer electronics|Gadgets & Gizmos|Software Development - Agile|Software Development Kit (SDK)|Technical Documentation|Programming Languages - C, C++, Java, NodeJs, PHP, React, Native, Python, R|DevOps|Cloud Computing|API Management|Operating Systems|Software Libraries|Software Testing - Manual Testing, Automated Testing, Quality Assurance Engineering|Database Technology|IT Operations|Software Modelling Tools - MATLAB,|Mobile Application Development|Product Management - Strategy and Technical Product Management|Product Development|Digital Automation|Product Management Tools (Tracking & analytics, roadmapping, customer survey, industry information, etc.)|Firewalls|Digital Media - Social Platforms,|Music|Cinema|OTT|Podcasts|Publishing - Book Publishing, Self-Publishing, Digital Platforms|News & Journalism - Digital and Print|Procurement and Vendor Management|Supply Chain Management|Fleet Management|Production Logistics - Materials Management, Distribution in Factories, Shipping|Sales Logistics - Warehousing, Wholesale, Distribution & Retail|Last mile logistics|International & Domestic Shipping|Transport Tech - Software and Management|Mobility as a Service - Shuttles, Ride-hailing, Rentals - Cars, Bicycle|Parking Management|Electric Vehicles - Manufacturing, Charging, Rentals, Services|Music - Art|Art (all mediums)|Cinema - Art|Theatre|Literature|Photography|Design - Graphic Design, UI/UX Design, Design Thinking|Instructional Design|Academics - K12|Academics - Higher Education (Bachelors, Masters, Specializations)|Academics - Competitive Examinations (IITJEE, NEET, UPSC, CLAT, etc.)|Vocational Education|Higher Education & Career Guidance|Professional Development & Continuous Learning & Upskilling|Open & Distance Learning|Politics|Culture|Languages|Philosophy|History, Archaeology, Anthropology|Sociology|Religion|Geography|Baby Care|Child Psychology|Parenting|Pet Care|Elderly Care|Nutrition|Physical Wellness|Mental Wellness|Healthtech - Telemedicing, Healthcare IT|Diagnostics & Preventive Care|Healthcare Services - Payers & Providers|Public Health|Primary, Secondary, Tertiary and Home Healthcare|Healthcare Policies|Alternative medicine|Media and Press/Public Relations|Marketing Tech - Marketing Analytics, Tools|Advertising - Media Buying, Programmatic, Ad-tech|B2B Marketing|ATL & BTL Marketing|Community Marketing - Events, Webinars and Conferences|Branding|Consumer Behaviour and Insights|Digital Marketing -Content Marketing, SEO, Social Media, Performance Marketing, Email Marketing, Influencer Marketing and Affliate Marketing|Pharmacy|Drug and Pharamaceutical Manufacturing/Biotech/R&D|Medical Equipment|Biologicals|Construction - Buildings, Infrastructure and Industrial|Rental and Brokerage|Property Tech|Residential real estate|Commercial real estate|Industrial real estate|Real estate investing|Esports|Online Gaming Platforms|Online Sports Media|Fantasy Sports Platforms|Sports Tech - Wearable and Non-Wearable|Game development and publishing|Poker|Mobile games|Online Betting Games|Outdoor sports|Indoor sports|Travel and Tourisms|Events & Conferences|Food & Beverage|Fashion & Apparel|Interior Design, Decor and Architecture|Food & Beverage - Lifestyle|Beauty & Cosmetics|Climate Change and Environment Tech|Renewable Energy - Solar, Geothermal, Wind, Biomass, Hydropower|Non Renewable Energy - Petroleum, Hydrocarbons, Natural Gas, Coal, Nuclear|Oil, Gas & Chemicals|Industrial Equipment and Safety|Manufacturing Tech|Industrial Products & Construction|Mining & Metals|Power, Utilities & Renewables|Livestock - Tech and Produce|Crops - Tech and Produce|Farming|Online Grocery|Agriculture E-commerce|Human Resources Management|Change Management and Experiences|Learning and Development|HR Tech|Recruitment and Staffing|Freelancing and Gig Economy|BPO, KPO - Research, Analytics|Organizational Behaviour|Talent Management|Auto E-commerce and Content|Connected and Autonomous Vehicles|Auto Components|Auto Brands",
});

export default constants;
